// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__m8Upc","header":"ReportDetails_header__3TrXh","title":"ReportDetails_title__1QNEg","left":"ReportDetails_left__2a0AQ"};